module.exports = __webpack_public_path__ + "media/message 1.03fab173.mp3";